import React from 'react';
import { Icon, Tooltip } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { formatWithCommas } from '@perch-labs/warbler';
import { LabelAndTooltip } from 'styles';
import {
  DataAndLabel,
  DataAndLabelHorizontalList,
} from 'components/data-and-label';

const getCopy = copyFor('solar.projectDetails.statistics');

interface Props {
  homesPoweredAnnually?: number;
  mwhProducedAnnually?: number;
}

export const ProjectStatistics = (props: Props) => {
  const { homesPoweredAnnually, mwhProducedAnnually } = props;
  const megawattHourLabel = (
    <LabelAndTooltip>
      {getCopy('mwhProducedAnnually')}
      <Tooltip
        content={getCopy('mwhTooltip')}
        tooltipId="MWH"
        label={getCopy('mwhTooltipLabel')}
      >
        <Icon icon="InfoCircleInverted" />
      </Tooltip>
    </LabelAndTooltip>
  );

  return (
    <DataAndLabelHorizontalList margin={{ top: '16px' }}>
      <DataAndLabel
        labelTextStyle="paragraph400"
        label={getCopy('homesPoweredAnnually')}
        value={
          homesPoweredAnnually !== undefined
            ? formatWithCommas(homesPoweredAnnually, 0)
            : undefined
        }
      />
      <DataAndLabel
        label={megawattHourLabel}
        value={
          mwhProducedAnnually !== undefined
            ? formatWithCommas(mwhProducedAnnually, 0)
            : undefined
        }
      />
    </DataAndLabelHorizontalList>
  );
};
